"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1791],{

/***/ 1791:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "SectionProcessSteps": function() { return /* binding */ SectionProcessSteps; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(79570);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/react/index.js
var react = __webpack_require__(16405);
// EXTERNAL MODULE: ../../libs/styles/src/index.ts + 15 modules
var src = __webpack_require__(55022);
// EXTERNAL MODULE: ../../node_modules/react-intersection-observer/react-intersection-observer.modern.mjs
var react_intersection_observer_modern = __webpack_require__(30299);
// EXTERNAL MODULE: ../../libs/components/src/index.ts + 122 modules
var components_src = __webpack_require__(75762);
// EXTERNAL MODULE: ../../libs/icons/src/index.ts + 18 modules
var icons_src = __webpack_require__(46115);
;// CONCATENATED MODULE: ../../libs/page-builder/src/lib/SectionProcessSteps/stepCard.tsx





const StepCardContainer = (0,src/* styled */.zo)("div", {
    display: "flex",
    flexDirection: "column",
    gap: "$32",
    alignItems: "flex-start",
    scrollSnapAlign: "start",
    borderRadius: "$rBoxes",
    border: "1px solid #2D2D2D",
    position: "relative",
    height: "inherit",
    padding: "$30",
    minWidth: "290px",
    maxWidth: "290px",
    "@md": {
        border: "none",
        padding: "0",
        minWidth: "auto",
        maxWidth: "auto"
    }
});
const StepNumber = (0,src/* styled */.zo)("div", {
    display: "flex",
    width: "80px",
    height: "80px",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "40px",
    border: "1px solid $white",
    projectFont: "ui02",
    color: "$white",
    textAlign: "center",
    lineHeight: "120%"
});
const StepTitle = (0,src/* styled */.zo)("h3", {
    projectFont: "heading04",
    color: "$white",
    "@md": {
        projectFont: "heading07",
        width: "260px",
        paddingRight: "60px",
        minWidth: "260px"
    },
    variants: {
        isLast: {
            true: {
                "@md": {
                    width: "200px",
                    paddingRight: "0",
                    minWidth: "200px"
                }
            }
        }
    }
});
const StepContent = (0,src/* styled */.zo)("div", {
    projectFont: "heading08",
    color: "$gray300",
    fontWeight: 450,
    lineHeight: "120%",
    letterSpacing: "-0.18px",
    "& p": {
        margin: 0,
        padding: 0
    },
    "& p + p": {
        marginTop: "22px"
    },
    "@md": {
        width: "260px",
        paddingRight: "60px",
        minWidth: "260px"
    },
    variants: {
        isLast: {
            true: {
                "@md": {
                    width: "200px",
                    paddingRight: "0",
                    minWidth: "200px"
                }
            }
        }
    }
});
const NumberContainer = (0,src/* styled */.zo)("div", {
    display: "flex",
    flexDirection: "row",
    gap: "$30",
    width: "100%"
});
const IconContainer = (0,src/* styled */.zo)("div", {
    display: "none",
    "@md": {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flex: 1
    }
});
const StepCard = /*#__PURE__*/ (0,react.forwardRef)((param, ref)=>{
    let { step , index , isLast  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StepCardContainer, {
        ref: ref,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(NumberContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StepNumber, {
                        children: String(index + 1).padStart(2, "0")
                    }),
                    !isLast && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconContainer, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_src/* DashedLine */.c7, {})
                    })
                ]
            }),
            step.title && /*#__PURE__*/ (0,jsx_runtime.jsx)(StepTitle, {
                isLast: isLast,
                children: step.title
            }),
            step.content && /*#__PURE__*/ (0,jsx_runtime.jsx)(StepContent, {
                isLast: isLast,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_src/* PortableText */.YI, {
                    value: step.content,
                    appearance: "plain"
                })
            })
        ]
    });
});

;// CONCATENATED MODULE: ../../libs/page-builder/src/lib/SectionProcessSteps/SectionProcessSteps.tsx







const Container = (0,src/* styled */.zo)("div", {
    gap: "72px",
    display: "flex",
    flexDirection: "column",
    "@md": {
        gap: "$30"
    },
    "@xxl": {
        maxWidth: "$maxWidthDesktop",
        margin: "0 auto"
    }
});
const Title = (0,src/* styled */.zo)("h2", {
    projectFont: "heading02",
    color: "$white",
    textAlign: "center",
    paddingInline: 20,
    "@md": {
        padding: "$24 $12"
    },
    "@xxl": {
        paddingInline: 0
    }
});
const Description = (0,src/* styled */.zo)("p", {
    display: "none",
    "@md": {
        display: "flex",
        padding: "$0",
        maxWidth: "600px",
        margin: "0 auto",
        projectFont: "heading07",
        color: "$gray300",
        textAlign: "center"
    }
});
const ArrowButton = (0,src/* styled */.zo)(components_src/* Button */.zx, {
    display: "none",
    "@md": {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "absolute",
        top: "45%",
        transform: "translateY(-45%)",
        zIndex: "$sliderArrows",
        width: "$56",
        height: "$56",
        borderRadius: "$rMax",
        transition: "0.2s background",
        "&:nth-of-type(1)": {
            left: "$56"
        },
        "&:nth-of-type(2)": {
            right: "$56"
        },
        background: "$gray500_02",
        backdropFilter: "blur(10px)",
        "&:hover": {
            background: "$gray500_03"
        },
        "&:active": {
            background: "$gray500_04"
        },
        "&:focus-visible": {
            outline: "$focusBlue solid 3px;"
        },
        "&:disabled": {
            display: "none"
        }
    }
});
const ScrollWrapper = (0,src/* styled */.zo)("div", {
    position: "relative",
    overflowX: "hidden",
    ["& ".concat(ArrowButton)]: {
        opacity: 0,
        transition: "transform 0.4s ease-in, opacity 0.5s cubic-bezier(0.15, 0, 0.2, 1) 0.1s",
        transform: "scale(0.8)"
    },
    "&:hover": {
        ["& ".concat(ArrowButton)]: {
            opacity: 1,
            transition: "transform 0.4s ease-in, opacity 0.5s cubic-bezier(0.15, 0, 0.2, 1) 0.1s",
            transform: "scale(1)"
        }
    }
});
const StepsScrollContainer = (0,src/* styled */.zo)("div", {
    display: "flex",
    gap: "$20",
    overflowX: "auto",
    overflowY: "hidden",
    scrollSnapType: "x mandatory",
    padding: "$0 $20",
    scrollPadding: "$0 $20",
    "&::-webkit-scrollbar": {
        display: "none"
    },
    "@md": {
        gap: "$30"
    },
    "@xl": {
        justifyContent: "center"
    }
});
const SectionProcessSteps = (param)=>{
    let { title , description , steps , spacing , topBorder  } = param;
    const scrollContainerRef = (0,react.useRef)(null);
    const [isFirstVisible, setIsFirstVisible] = (0,react.useState)(true);
    const [isLastVisible, setIsLastVisible] = (0,react.useState)(false);
    const scrollSteps = (stepsToScroll)=>{
        const container = scrollContainerRef.current;
        if (!container) return;
        const firstStep = container.firstChild;
        const secondStep = container.childNodes[1];
        if (!firstStep || !secondStep) return;
        const stepWidth = firstStep.getBoundingClientRect().width;
        const gutterWidth = secondStep.getBoundingClientRect().left - firstStep.getBoundingClientRect().right;
        const destination = stepsToScroll * stepWidth + stepsToScroll * gutterWidth;
        container.scrollBy({
            left: destination,
            behavior: "smooth"
        });
    };
    if (!steps || steps.length === 0) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_src/* SectionWrapper */.Uq, {
        type: spacing || "MEDIUM",
        topBorder: topBorder,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
            children: [
                title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                    children: title
                }),
                description && /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {
                    children: description
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ScrollWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowButton, {
                            onClick: ()=>scrollSteps(-1),
                            disabled: isFirstVisible,
                            "aria-label": "previous",
                            appearance: "default",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_src/* ArrowPrev */.zF, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowButton, {
                            onClick: ()=>scrollSteps(1),
                            disabled: isLastVisible,
                            "aria-label": "next",
                            appearance: "default",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_src/* ArrowNext */.Tg, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StepsScrollContainer, {
                            ref: scrollContainerRef,
                            children: steps.map((step, index)=>{
                                const isFirst = index === 0;
                                const isLast = index === steps.length - 1;
                                if (isFirst || isLast) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_intersection_observer_modern/* InView */.df, {
                                        threshold: 1,
                                        root: scrollContainerRef.current,
                                        rootMargin: "0%",
                                        onChange: (inView)=>{
                                            if (isFirst) {
                                                setIsFirstVisible(inView);
                                            }
                                            if (isLast) {
                                                setIsLastVisible(inView);
                                            }
                                        },
                                        children: (param)=>/*#__PURE__*/ {
                                            let { ref  } = param;
                                            return (0,jsx_runtime.jsx)(StepCard, {
                                                ref: ref,
                                                step: step,
                                                index: index,
                                                isLast: isLast
                                            });
                                        }
                                    }, step._key);
                                }
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StepCard, {
                                    step: step,
                                    index: index,
                                    isLast: isLast
                                }, step._key);
                            })
                        })
                    ]
                })
            ]
        })
    });
};


/***/ })

}]);